import { render, staticRenderFns } from "./TrainingCoursesEditForm.vue?vue&type=template&id=2a942397&"
import script from "./TrainingCoursesEditForm.vue?vue&type=script&lang=js&"
export * from "./TrainingCoursesEditForm.vue?vue&type=script&lang=js&"
import style0 from "./TrainingCoursesEditForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports